const selectors = {
	iconTile: '.tile--image-size-icon',
	icon: '.tile__icon',
};

const iconTiles = document.querySelectorAll(selectors.iconTile);

const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		const tile = entry.target;
		if (entry.isIntersecting) {
			const icon = tile.querySelector(selectors.icon);

			if (icon) {
				const maskImage = icon.getAttribute('data-mask-img');

				if (maskImage) {
					icon.style.setProperty('--mask-img-url', `url(${maskImage})`);
					icon.setAttribute('data-loaded', 'true');
				}
			}

			observer.unobserve(icon);
		}
	});
});

if (iconTiles.length) {
	iconTiles.forEach((tile) => observer.observe(tile));
}
